package com.example.mystybag.sharedmodels.project.requestModels.merchant

import com.example.mystybag.sharedmodels.AllCommands.GET_MERCHANT_MENU_DATA
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
data class GetMerchantMenuDataRequestModel(
    val merchantId: Long
) : BaseRequestModel(api = GET_MERCHANT_MENU_DATA)

